import styled from 'styled-components';

export const TITLE_SIZE_REGULAR_MOBILE = 22;
export const TITLE_SIZE_REGULAR_DESKTOP = 30;

export const NftCardsEmptyWrapper = styled.div`
    max-width: 856px;
    position: relative;
    margin: 0 auto 50px auto;
    padding: 30px;
    height: auto;
    align-items: center;
    display: flex;
    justify-content: center;
    backdrop-filter: blur(0);
    background: rgba(255, 255, 255, 0.05);
    transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    border-radius: 11px;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        border-radius: 20px;
    }

    div[type='headline'] {
        font-size: ${TITLE_SIZE_REGULAR_MOBILE}px;

        @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
            font-size: ${TITLE_SIZE_REGULAR_DESKTOP}px;
        }
    }

    div[type='paragraph'] {
        margin: 30px 0;
        opacity: 0.5;
    }

    .yat-metamask-connection-button {
        // TODO: Gradient uses a rotation that is not widely supported
        // and may not behave as expected.
        background: radial-gradient(102.5% 1778.81% at 102.93% 143.75%, #000000 0%, #523df1 100%);
        box-shadow:
            0 0 14px rgba(82, 61, 241, 0.6),
            inset 0 0 30px #523df1;

        &:hover {
            background: white;
            box-shadow: none;
        }
    }
`;

export const StyledNoNftColumn = styled.div`
    display: block;
    align-items: center;
    position: relative;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 45%;
        margin: 5%;
    }

    &:last-child {
        display: none;
        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            display: block;
        }
    }
`;

export const StyledYatHandWrap = styled.div`
    height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 2px 0 #000000bf inset;
    background: radial-gradient(
            70.94% 70.94% at 36.73% 29.06%,
            rgba(255, 255, 255, 0.05) 0%,
            rgba(255, 255, 255, 0) 100%
        )
        rgba(255, 255, 255, 0.06);

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        padding-bottom: 50%;
        padding-top: 50%;
    }

    svg {
        width: 59px;
        height: 66px;
        fill: white;
        opacity: 0.1;
    }
`;
